import { z } from "zod";

export const ICON_TYPES = [
  "badge-check",
  "bell-solid",
  "book",
  "bookmark",
  "briefcase",
  "briefcase-outlined",
  "building",
  "building-thick",
  "calendar",
  "caret-bottom",
  "caret-double-left",
  "caret-double-right",
  "centered-circle",
  "chart-line-increase",
  "chevron-left",
  "chevron-right",
  "clock",
  "clock-outlined",
  "close",
  "cogwheel",
  "coordinates-person",
  "clipboard-bunny-gold",
  "dash",
  "dollar",
  "door-straight",
  "ellipsis",
  "files",
  "folder-person",
  "folder-view",
  "gps-disabled",
  "group",
  "house-building",
  "hybrid-view",
  "identity-card",
  "information-circle",
  "location-alt",
  "magnifying-glass",
  "map-pin",
  "medal-star-alt",
  "message",
  "microscope",
  "money-dollar",
  "notepad-alt",
  "notepad-problem",
  "padlock-locked",
  "palm-dollar",
  "people",
  "person-male",
  "person-male-formal",
  "person-superstar",
  "plus",
  "profile",
  "question-circle",
  "replay",
  "ribbon",
  "route",
  "stack-vertical",
  "student",
  "triangle-down",
  "variant",
] as const;

export type IconType = typeof ICON_TYPES[number];

export const iconTypeSchema = z.enum(ICON_TYPES);
